import type { EnrichmentStatusResponse } from '@factoryfixinc/ats-interfaces';

import { useAtsConversationApiWithOptions } from '@/composables/useApi';
import { InternalError } from '@/core/shared/errors/internal.error';

export default class EnrichmentStatusPersistence {
  async fetchStatuses(userProfileIds: number[]): Promise<EnrichmentStatusResponse> {
    const query = new URLSearchParams({ userProfileIds: userProfileIds.join(',') });
    const url = `/enrichment/status?${query.toString()}`;
    const { data, error, statusCode } = await useAtsConversationApiWithOptions({
      suppressConnectionIssue: true,
    })(url)
      .get()
      .json<EnrichmentStatusResponse>();

    if (error.value) {
      throw new InternalError('Failed to fetch enrichment statuses', {
        error: error.value,
        status: statusCode.value,
        data: { userProfileIds },
      });
    }

    return data.value ?? {};
  }
}
